<template>
  <div class="maincon maintab">
    <div class="destab">
      <span class="back" @click="$router.back()"></span>
      <span
        @click="childClick(0, i, item)"
        v-for="(item, i) in tabText"
        :key="i"
        :class="{ on: i === nowIndex }"
        >{{ item }}</span
      >
    </div>
    <span @click="childClick(1)"
      >{{ selectTimeText }}<span class="funnelicon"></span
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    // tabs数据
    tabText: {
      type: Array
    },
    // 当前选中
    selectTimeText: {
      type: String
    },
    // 当前选中元素索引
    nowIndex: {
      type: Number
    }
  },
  data() {
    return {
      active_text: this.$t('text.paymentProgressQuery.all')
    }
  },
  mounted() {
    console.log(this.tabText)
  },
  methods: {
    childClick(type, i, item) {
      this.$emit('barClick', type, i, item)
    }
  }
}
</script>
<style scoped lang="scss">
.maincon {
  background-color: #fff;
  width: 94.66%;
  margin: 0 auto 10px;
  &.maintab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 10;
    position: relative;
    .destab {
      width: 62%;
      margin-left: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .back {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(~@/assets/image/common/back_arrow.png) no-repeat
          center/16px 16px;
      }
      span {
        padding: 18px 0;
        &.on {
          font-size: 15px;
          font-weight: bold;
          position: relative;
          &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 2px;
            width: 25px;
            background-color: #c7a283;
            border-radius: 1px;
            margin: 0 auto;
          }
        }
      }
    }
    & > span {
      padding-left: 20px;
      height: 13px;
      border-left: 1px solid rgba(51, 51, 51, 0.3);
      margin-right: 30px;
      display: flex;
      align-items: center;
      .funnelicon {
        display: inline-block;
        width: 10px;
        height: 13px;
        background: url(~@/assets/image/common/funnelicon.png) center center
          no-repeat;
        background-size: contain;
        margin-left: 5px;
      }
    }
  }
}
</style>
